<!--
	* @Description: 学生惩处 添加
	* @Author: ZSC
	* @Date: 2023-04-07 16:11:57.971
 * @LastEditors: PF
 * @LastEditTime: 2024-01-02 13:29:31
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学生" prop="xsid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xsid" clearable filterable>
                <el-option v-for="item in xsData" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级" prop="bjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.bjid" clearable filterable @change="xsChange">
                <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班主任" prop="bzrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.bzrid" clearable filterable>
                <el-option v-for="item in jzgData" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable>
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="违纪日期" prop="wjrq" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.wjrq" type="date" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="违纪简况" prop="wjjk">
              <el-input v-model="ruleForm.wjjk" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="违纪类别" prop="wjlbid">
              <el-select v-model="ruleForm.wjlbid" clearable filterable>
                <el-option v-for="item in wjlbData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处分名称" prop="cfmcid">
              <el-select v-model="ruleForm.cfmcid" clearable filterable>
                <el-option v-for="item in cfmcData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="处分日期" prop="cfrq">
              <el-date-picker v-model="ruleForm.cfrq" type="date" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处分文号" prop="cfwh">
              <el-input v-model="ruleForm.cfwh" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处分撤销日期" prop="cfcxrq">
              <el-date-picker v-model="ruleForm.cfcxrq" type="date" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处分撤销文号" prop="cfcxwh">
              <el-input v-model="ruleForm.cfcxwh" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处分原因" prop="cfyy">
              <el-input v-model="ruleForm.cfyy" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
// import { loadJiGouCascader } from '@/api/queryJiGou.js'

const props = defineProps({
  openAdd: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const wjlbData = ref()
const cfmcData = ref()
const xqData = ref()
const xsData = ref()
const bjData = ref()
const jzgData = ref()
const xsChange = (val) => {
  
  loadSelect({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    data: xsData,
    parms: { bjid: val },
    order: 'xh',
    sort: 'asc'
  })
  bjData.value.forEach((element) => {
    if (element.id === val) {
      // ruleForm.value.bzrid = element.bzrid
    }
  })
}

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadZiDianSelect('违纪类别', wjlbData)
      loadZiDianSelect('处分名称', cfmcData)
      
      ruleForm.value.bzrid = props.row.jzgid
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              ruleForm.value.xqid = element.id
              // 
            }
          })
        }
      })
      loadSelect({
        url: '/api/v2/pdp/banji/list',
        data: bjData,
        parms: { bzrid: props.row.jzgid },
        order: 'xzbmc',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/pdp/jiaozhigong/list',
        data: jzgData,
        order: 'gh',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/pdp/xuesheng/list',
        data: xsData,
        order: 'xh',
        sort: 'asc'
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  // ruleForm.value.kkdwid = Array.isArray(ruleForm.value.kkdwid) ? ruleForm.value.kkdwid[ruleForm.value.kkdwid.length - 1] : ruleForm.value.kkdwid
  submitForm({
    url: '/api/v2/xuesheng/xueshengchengchu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
